"use client";

import React, { useEffect, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface Sparkle {
  id: number;
  x: number;
  y: number;
  size: number;
  rotation: number;
  opacity: number;
  color: string;
}

export default function SparklingTrail() {
  const [sparkles, setSparkles] = useState<Sparkle[]>([]);

  const addSparkle = useCallback((x: number, y: number) => {
    const newSparkle: Sparkle = {
      id: Math.random(),
      x,
      y,
      size: Math.random() * 12 + 8,
      rotation: Math.random() * 360,
      opacity: Math.random() * 0.5 + 0.5,
      color: ['#a91b8d', '#24a8e1', '#FFFFFF'][Math.floor(Math.random() * 3)],
    };

    setSparkles((prev) => [...prev.slice(-20), newSparkle]);

    setTimeout(() => {
      setSparkles((prev) => prev.filter((s) => s.id !== newSparkle.id));
    }, 800);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (Math.random() > 0.3) {
        addSparkle(e.clientX, e.clientY);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [addSparkle]);

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999] overflow-hidden">
      <AnimatePresence>
        {sparkles.map((sparkle) => (
          <motion.div
            key={sparkle.id}
            initial={{ opacity: 0, scale: 0, rotate: sparkle.rotation }}
            animate={{ 
              opacity: [0, 1, 0], 
              scale: [0, 1.2, 0.5], 
              y: sparkle.y + 30, 
              rotate: sparkle.rotation + 90 
            }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="absolute left-0 top-0"
            style={{ 
              x: sparkle.x, 
              y: sparkle.y, 
              translateX: "-50%", 
              translateY: "-50%" 
            }}
          >
            <svg
              width={sparkle.size}
              height={sparkle.size}
              viewBox="0 0 24 24"
              fill={sparkle.color}
              className={sparkle.color === '#FFFFFF' ? "drop-shadow-[0_0_8px_rgba(255,255,255,0.8)]" : "drop-shadow-[0_0_8px_rgba(169,27,141,0.8)]"}
              style={{ opacity: sparkle.opacity }}
            >
              <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
            </svg>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}